export default "__VITE_ASSET__CgKmNNth__"